import { Chart } from 'chart.js';
import { getVoteColor } from '../theme';
import { customTooltipCallback } from '../tooltip';
import { VotesChartSettings } from './types';

export function setupVotesChart(
  chartContext: HTMLCanvasElement,
  settings: VotesChartSettings
) {
  if (settings.isEmpty) {
    createEmptyChart(chartContext);
  } else {
    createChart(chartContext, settings);
  }
}

function createChart(
  chartContext: HTMLCanvasElement,
  settings: VotesChartSettings
) {
  const data = settings.dataSet.data;

  new Chart(chartContext, {
    type: 'doughnut',
    data: {
      labels: data.map((d) => d.label),
      datasets: [
        {
          label: settings.title,
          data: data.map((x) => x.value),
          backgroundColor: data.map((x) => getVoteColor(x.voteType)),
          borderColor: data.map((x) => getVoteColor(x.voteType)),
        },
      ],
    },
    options: {
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
        tooltip: {
          enabled: false,
          external: customTooltipCallback,
        },
      },
    },
  });
}

function createEmptyChart(chartContext: HTMLCanvasElement) {
  const color = '#f2f2f3';

  new Chart(chartContext, {
    type: 'doughnut',
    data: {
      labels: [],
      datasets: [
        {
          data: [1],
          backgroundColor: color,
          borderColor: color,
          hoverBackgroundColor: color,
          hoverBorderColor: color,
        },
      ],
    },
    options: {
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
        tooltip: {
          enabled: false,
        },
      },
    },
  });
}
